<template>
  <form class="form-horizontal" @submit.prevent="updateEmail">
    <div class="row">
      <label class="col-sm-2 col-form-label">Email ID
        <strong class="text-danger">*</strong>
      </label>
      <div class="col-sm-8">
        <div class="form-group">
          <input type="email" disabled class="form-control" required v-model.trim="customer.email">
          <span class="form-text">Enter your updated email ID for the BigScoots WordPress dashboard.</span>
        </div>
      </div>
<!--      <div class="col-sm-4">-->
<!--        <button class="btn btn-danger mt-0 text-white" :disabled="!customer.email">Update Email</button>-->
<!--      </div>-->
    </div>
  </form>
</template>

<script>
import { functions } from "@/firebase/init";

export default {
  name: "EmailDetailsUpdate",
  computed: {
    docID() {
      return this.$store.getters.getUID;
    }
  },
  data() {
    return {
      customer: {
        email: this.$store.getters["customer/email"]
      }
    };
  },
  methods: {
    updateEmail() {
      // Check the email id field is not blank
      if (this.customer.email) {
        // Check if the provided email id is actually an email or not
        const emailCheckRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailCheckRegex.test(this.customer.email)) {
          // Now we know that the entered email is a completely valid email
          // Set the asyncDone to false
          this.$store.dispatch("async/stateUpdate", { state: false });

          // Call firebase cloud function updateUserEmail to update the email id in the firebase auth as well as firestore users collection by passing the fireabse auth UID and the new updated email id
          const updateUserEmail = functions.httpsCallable("updateUserEmail");
          updateUserEmail({
            uid: this.docID,
            newEmail: this.customer.email
          })
            .then(result => {
              if (result.data.message === "success") {
                // Update the email to teh Vuex state
                this.$store.dispatch("customer/emailUpdate", {
                  email: this.customer.email
                });

                // set asyncDone to true
                this.$store.dispatch("async/stateUpdate", { state: true });

                // Show the alert to the admin for 8 seconds
                this.$store.dispatch("alert/update", {
                  type: "success",
                  message: 'Your email id has successfully been updated.',
                  show: true
                });

                setTimeout(() => {
                  this.$store.dispatch("alert/showUpdate", {
                    show: false
                  });
                }, 8000);
              }
            })
            .catch(err => {
              // set asyncDone to true
              this.$store.dispatch("async/stateUpdate", { state: true });

              // Show the alert to the admin for 5 seconds
              this.$store.dispatch("alert/update", {
                type: "danger",
                message: err,
                show: true
              });
                this.addLog({
                    message: "Error: Error update user email. Message:" + err.message,
                    level:  "danger"
                });
              setTimeout(() => {
                this.$store.dispatch("alert/showUpdate", {
                  show: false
                });
              }, 5000);
            });
        } else {
          // Show the alert to the admin for 5 seconds
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: "Please enter a valid Email ID",
            show: true
          });

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {
              show: false
            });
          }, 5000);
        }
      } else {
        // Show the alert to the admin for 5 seconds
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: "Please enter a valid Email ID",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {
            show: false
          });
        }, 5000);
      }
    }
  }
};
</script>
